import { Box, styled } from "@mui/material";

import { isMobile } from "@hooks/layout";

export const CategoryButton = styled(Box)<{ $isSelected: boolean }>`
  min-width: fit-content;
  padding: 8px 16px;

  font-family: Raleway;
  font-weight: 400;
  color: #fbf4ec;
  cursor: pointer;

  border-radius: 4px;

  background: #453425cc;

  &:hover {
    background: #ffdca8;
    color: #4b3628;
  }

  ${({ $isSelected }) =>
    $isSelected &&
    `
        color: #4b2628;
        background: #ffdca8;
      `}
`;

export const CategoryButtonsWrapper = styled(Box)`
  display: flex;
  gap: 16px;
  height: fit-content;
  grid-column: span 12;
  overflow: auto;

  ${isMobile} {
    margin-bottom: 42px;

    scrollbar-width: none;

    &::-webkit-scrollbar {
      -webkit-appearance: none;
      display: none;
      width: 0;
      height: 0;
    }
  }
`;
